import { render } from "./pos-prefixes.vue?vue&type=template&id=2725edec"
import script from "./pos-prefixes.vue?vue&type=script&lang=js"
export * from "./pos-prefixes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__